/* TooltipHeader.tsx generated by @compiled/babel-plugin v0.28.8 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _6 = "._slp31hna{word-wrap:break-word}";
const _5 = "._k48p1nn1{font-weight:400}";
const _4 = "._ect41wi2{font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",\"Roboto\",\"Oxygen\",\"Ubuntu\",\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif}";
const _3 = "._1wyb1skh{font-size:11px}";
const _2 = "._syaz1glm{color:var(--ds-text,grey)}";
const _ = "._1wpz1fhb{align-self:stretch}";
const headerCss = null;
export function TooltipHeader(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1wpz1fhb _syaz1glm _1wyb1skh _ect41wi2 _k48p1nn1 _slp31hna"]),
      children: children
    })]
  });
}